<template>
    <div class="content">
        <!--<h3>{{ headerInfo }}</h3>-->
        <p>{{ addressinfo }}</p>
        <br>
        <p
            v-if="slotData.tableData"
            class="content-text-info"
        >
            {{ tableInfo }}
        </p>
        <dynamic-table
            v-if="slotData.tableData"
            :table-data="slotData.tableData"
        />
        <p class="content-text-info">
            {{ mapInfo }}
        </p>
        <!-- eslint-disable vue/no-v-html -->
        <p class="content-text-info">
            <span v-html="infotext" />
        </p>
        <!--eslint-enable-->
        <br>
    </div>
</template>

<script lang="ts">
    import { Component, Vue } from "vue-facing-decorator"
    import DynamicRightSlotData from "@/models/dynamicrighslotdata"
    import DynamicTable from "@/components/DynamicTable.vue"
    import LatLngPoint from "@/models/latlngpoint"
    import SearchResultModel from "@/models/searchresultmodel"

    @Component({
        components: {
            "dynamic-table": DynamicTable
        }
    })
    export default class OikeusPuhelinJaLaajakaistaLiittymaan extends Vue {
        get slotData(): DynamicRightSlotData | null {
            return this.$store.getters.rightSlotData as DynamicRightSlotData
        }

        get coordinates(): LatLngPoint | null {
            return this.$store.getters.coordinates
        }

        get dropDownSelected(): string {
            return this.$store.getters.dropDownSelected
        }

        get tableInfo(): string | undefined {
            return this.$t("App.OikeusPuhelinJaLaajakaistaLiittymaan.RightSlot.TableInfo.All")
        //    switch (this.dropDownSelected) {
        //        case "":
        //            return this.$t("App.OikeusPuhelinJaLaajakaistaLiittymaan.RightSlot.TableInfo.All")
        //        case "Puhelinpalvelu":
        //            return this.$t("App.OikeusPuhelinJaLaajakaistaLiittymaan.RightSlot.TableInfo.Puhelinpalvelu")
        //        case "512k512klaajakaista":
        //            return this.$t("App.OikeusPuhelinJaLaajakaistaLiittymaan.RightSlot.TableInfo.512k512klaajakaista")
        //        case "Tekstiviestipalvelu":
        //            return this.$t("App.OikeusPuhelinJaLaajakaistaLiittymaan.RightSlot.TableInfo.Tekstiviestipalvelu")
        //        case "5Mlaajakaista":
        //            return this.$t("App.OikeusPuhelinJaLaajakaistaLiittymaan.RightSlot.TableInfo.5Mlaajakaista")
        //        default:
        //            return this.$t("App.OikeusPuhelinJaLaajakaistaLiittymaan.RightSlot.TableInfo.All") ?? ""
        //    }
        }

        get mapInfo(): string | undefined {
            switch (this.dropDownSelected) {
                case "":
                    return this.$t("App.OikeusPuhelinJaLaajakaistaLiittymaan.RightSlot.MapInfo.All")
                case "Puhelinpalvelu":
                    return this.$t("App.OikeusPuhelinJaLaajakaistaLiittymaan.RightSlot.MapInfo.Puhelinpalvelu")
                case "512k512klaajakaista":
                    return this.$t("App.OikeusPuhelinJaLaajakaistaLiittymaan.RightSlot.MapInfo.512k512klaajakaista")
                case "Tekstiviestipalvelu":
                    return this.$t("App.OikeusPuhelinJaLaajakaistaLiittymaan.RightSlot.MapInfo.Tekstiviestipalvelu")
                case "5Mlaajakaista":
                    return this.$t("App.OikeusPuhelinJaLaajakaistaLiittymaan.RightSlot.MapInfo.5Mlaajakaista")
                default:
                    return this.$t("App.OikeusPuhelinJaLaajakaistaLiittymaan.RightSlot.MapInfo.All")
            }
        }

        get infotext(): string | undefined {
            return this.$t("App.OikeusPuhelinJaLaajakaistaLiittymaan.RightSlot.InfoText")
        }

        get addressinfo(): string | undefined {
            if (this.searchAddressSelected !== null) {
                return this.$t("App.OikeusPuhelinJaLaajakaistaLiittymaan.RightSlot.InfoText.Address") + " " + this.searchAddressSelected.getFullName() + "."
            }
        }

        get searchAddressSelected(): SearchResultModel | null {
            return this.$store.getters.searchAddressSelected
        }

        // get headerInfo(): string | undefined {
        //    return this.$t("App.OikeusPuhelinJaLaajakaistaLiittymaan.DropDownList.All")
        // //    switch (this.dropDownSelected) {
        // //        case "":
        // //            return this.$t("App.OikeusPuhelinJaLaajakaistaLiittymaan.DropDownList.All")
        // //        case "Puhelinpalvelu":
        // //            return this.$t("App.OikeusPuhelinJaLaajakaistaLiittymaan.DropDownList.Puhelinpalvelu")
        // //        case "512k512klaajakaista":
        // //            return this.$t("App.OikeusPuhelinJaLaajakaistaLiittymaan.DropDownList.Laajakaista")
        // //        case "Tekstiviestipalvelu":
        // //            return this.$t("App.OikeusPuhelinJaLaajakaistaLiittymaan.DropDownList.Tekstiviestipalvelu")
        // //        case "5Mlaajakaista":
        // //            return this.$t("App.OikeusPuhelinJaLaajakaistaLiittymaan.DropDownList.5Mlaajakaista")
        // //        default:
        // //            return this.$t("App.OikeusPuhelinJaLaajakaistaLiittymaan.DropDownList.All")
        // //    }
        // }
    }
</script>
